angular.module('dashboard').controller('PrescriptionsDashboardCtrl',
    ['$scope', 'RxRefillRepository', 'PatientPortalStorageRepository', 'PrescriptionService', 'DashboardService',
        function ($scope, RxRefillRepository, PatientPortalStorageRepository, PrescriptionService, DashboardService) {

            'use strict';

            $scope.loading = true;
            
            $scope.load = function(tile) {
                $scope.tile = tile;

                loadPage();
            };

            function loadPage() {
                $scope.loading = true;
                $scope.removeHttpError();
                var activePatientId = PatientPortalStorageRepository.getActivePatient().id;

                RxRefillRepository
                    .getRxRefills(activePatientId, true)
                    .then(function (data) {
                        //prescriptions.html
                        var splitPrescriptions = _.partition(data.Medications, function (item) {
                            return PrescriptionService.dateFilter(item.EndDate, PrescriptionService.medFilters[1].Days);
                        });
                        $scope.currentPrescriptions = splitPrescriptions[0];
                        $scope.previousPrescriptions = splitPrescriptions[1];
                        
                        $scope.medicationsExist = $scope.currentPrescriptions ? !!$scope.currentPrescriptions.length : false;
                    })
                    .catch(function (response) {
                        $scope.addHttpError(response);
                    })
                    .finally(function () {
                        $scope.loading = false;
                    });
            }

            $scope.medSelect = function medSelect(med) {
                PrescriptionService.setSelectedMedId(med.RelPatientMedicationId);
            };

            $scope.updateCollapseState = function updateCollapseState() {
                $scope.tile.IsCollapsed = !$scope.tile.IsCollapsed;
                DashboardService.setPatientDashboardTileState($scope.tile);
            };

        }
    ]
);